var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestaurants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5546_324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1601 27.8613H4.85156V32.006H25.1601V27.8613Z",
    fill: "#EF916C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.009 8.37877C30.0154 7.26405 29.6883 6.17297 29.0698 5.24631C28.4513 4.31965 27.5698 3.59992 26.5391 3.17999C25.5084 2.76005 24.3758 2.65918 23.2873 2.89039C22.1988 3.1216 21.2044 3.67427 20.4325 4.47711C20.1797 3.21324 19.4977 2.07611 18.5026 1.25909C17.5074 0.442075 16.2605 -0.00439453 14.9739 -0.00439453C13.6873 -0.00439453 12.4404 0.442075 11.4452 1.25909C10.4501 2.07611 9.76809 3.21324 9.51527 4.47711C8.89405 3.8425 8.13028 3.36602 7.28775 3.08747C6.44522 2.80892 5.54839 2.73639 4.67217 2.87593C3.79595 3.01547 2.96577 3.36303 2.25098 3.88959C1.5362 4.41614 0.957542 5.10641 0.563355 5.90272C0.169168 6.69904 -0.029108 7.57829 -0.0149131 8.46704C-0.000718212 9.35579 0.225536 10.2282 0.644951 11.0115C1.06437 11.7948 1.66477 12.4661 2.39601 12.9695C3.12725 13.4729 3.9681 13.7937 4.84832 13.9051V24.1389H25.1569V13.9051C26.4981 13.7324 27.7305 13.0761 28.6235 12.0589C29.5166 11.0418 30.0092 9.73345 30.009 8.37877Z",
    fill: "#F75B11"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5546_324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurants);
export default __webpack_public_path__ + "static/media/restaurants.b3b2f633a68f15ed5326563a64db17cd.svg";
export { ForwardRef as ReactComponent };